import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { Button, DatePicker } from 'antd';

import { MASCARA_DDMMYYYY, esDataValidaSelectorObservacions, convertirTextAMomentLocal } from '../../commons/gestioDates';
import { crearNotificacioDatesObligatories, crearNotificacioSuperaPeriodeMaxim } from '../../commons/notificacio';
import errorBoundaryWrapper from '../commons/errorBoundaryWrapper';

const MAXIM_DIES_PERIODE = 31;

class ObservacioExportacioSelectorPeriode extends Component {

    constructor(props) {
        super(props);

        this.state = {
            dataInici: null,
            dataFi: null
        };

        this.esDiaDeshabilitat = this.esDiaDeshabilitat.bind(this);
        this.onSeleccionarPeriode = this.onSeleccionarPeriode.bind(this);
    }

    esDiaDeshabilitat(dataCalendari) {
        const dataActual = convertirTextAMomentLocal(this.props.dataActual);
        return esDataValidaSelectorObservacions(dataCalendari, dataActual, 'days');
    }

    onSeleccionarPeriode() {
        const dataIniciText = this.state.dataInici;
        const dataFiText = this.state.dataFi;
        const estacioSeleccionada = this.props.estacioSeleccionada;

        if (!dataIniciText || !dataFiText) {
            crearNotificacioDatesObligatories();
            return;
        }

        const dataInici = convertirTextAMomentLocal(dataIniciText);
        const dataFi = convertirTextAMomentLocal(dataFiText);

        if (!dataFi.isBetween(dataInici, dataInici.clone().add(MAXIM_DIES_PERIODE, 'days'), 'minute', '[]')) {
            crearNotificacioSuperaPeriodeMaxim(MAXIM_DIES_PERIODE);
            return;
        }

        this.props.obtenirObservacionsExportacioPerEstacio(dataInici, dataFi, estacioSeleccionada);
    }

    render() {
        return (
            <div className='observacio-exportacio-selector-periode'>
                <div className='selector-periode-titol'>
                    <div>{'Període de l\'exportació d\'observacions'}</div>
                    <div></div>
                </div>
                <div className='selector-periode-dades'>
                    <div className='selector-periode-data'>
                        <label>Data inici:</label>
                        <DatePicker
                            value={ this.state.dataInici }
                            format={ MASCARA_DDMMYYYY }
                            onChange={(data) => this.setState({ ...this.state, dataInici: data })}
                            disabledDate={ this.esDiaDeshabilitat }
                            allowClear={ false }
                        />
                    </div>
                    <div className='selector-periode-data'>
                        <label>Data fi:</label>
                        <DatePicker
                            value={ this.state.dataFi }
                            format={ MASCARA_DDMMYYYY }
                            onChange={(data) => this.setState({ ...this.state, dataFi: data })}
                            disabledDate={ this.esDiaDeshabilitat }
                            allowClear={ false }
                        />
                    </div>
                    <Button
                        type='primary'
                        onClick={this.onSeleccionarPeriode}
                        className='selector-periode-boto'>
                        Seleccionar
                    </Button>
                </div>
            </div>
        );
    }
}

ObservacioExportacioSelectorPeriode.propTypes = {
    dataActual: PropTypes.string.isRequired,
    estacioSeleccionada: PropTypes.number,
    obtenirObservacionsExportacioPerEstacio: PropTypes.func
};

export default errorBoundaryWrapper(ObservacioExportacioSelectorPeriode);



// WEBPACK FOOTER //
// ./src/components/observacio/observacioExportacioSelectorPeriode.js